<template>
  <settings>
    <coming-soon name="Billing"></coming-soon>
  </settings>
</template>

<script>
export default {
  name: 'SmartOeeBilling',
};
</script>

<style></style>
